import axiosInstance from 'api/axiosInstance'

export const getSubscriptionSelectedLists = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/subscription/selected-lists'
    })

    return data?.data
}
export const removeUsersFromSubscriptionList = async (
    id: string,
    users: string[]
): Promise<{ removed_count: number }> => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/subscription/list/${id}/remove-users`,
        data: { users }
    })

    return data.data
}
export const getSubscriptionLists = async (
    filter: string,
    sort: string = 'asc',
    currentPage: number = 1
) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: `/api/subscription/lists?sort_by=${filter}&sort_value=${sort}&page=${currentPage}`
        })
        return {
            nextCursor:
                currentPage < data?.meta?.last_page
                    ? currentPage + 1
                    : undefined,
            prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
            page: {
                data
            }
        }
    } catch (error) {
        console.error('Error:', error)
    }
}

export const getSubscriptionList = async (
    id: any,
    filter: number,
    type: 'active' | 'expired' = 'active',
    sort: number = 1, // 1 = ASC, 2 = DSC
    currentPage: number = 1
) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: `/api/subscription/lists/${type}/${id}?filter=${filter}&sort=${sort}&page=${currentPage}`
        })
        return {
            nextCursor:
                currentPage < data?.meta?.last_page
                    ? currentPage + 1
                    : undefined,
            prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
            page: {
                data
            }
        }
    } catch (error) {
        console.error('Error:', error)
    }
}

export const createSubscriptionList = async (name: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/subscription/list/create',
        data: { name }
    })

    return data.data
}

export const updateSubscriptionList = async (
  id: string,
  payload: {
    name?: string
    selected?: string[]
    orders?: Array<{ id: string; order: number }>
  }
) => {
  const { data } = await axiosInstance({
    method: 'PUT',
    url: `/api/subscription/list/${id}`,
    data: payload
  })

  return data
}

export const addUsersToSubscriptionList = async (
    id: string | undefined,
    users: string[]
) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/subscription/list/${id}/add-users`,
        data: { users }
    })
    return data
}

export const deleteSubscriptionList = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/subscription/list/${id}`
    })
console.log(data)
    return data
}
